import { fetchState } from './okFormResource';
import { FormState, FormAState, FormBState } from '@/models/enums';

class TokenState {
  formState: number;
  formAState: number;
  formBState: number;
  error: any = null;

  constructor(state: any, error?: any) {
    if (state) {
      this.formState = state.questionFormState;
      this.formAState = state.questionFormAState;
      this.formBState = state.questionFormBState;
    } else {
      this.formState = 0;
      this.formAState = 0;
      this.formBState = 0;
      this.error = error;
    }
  }
}

/**
 * Validate token (id) state.
 *
 * @param {string} token (UUID)
 * @param {boolean} noCheck skip validation
 * @returns {TokenState}
 */
export const getTokenState = async (token: string, noCheck?: boolean) => {
  if (noCheck) {
    return new TokenState({
      questionFormState: FormState.OPEN,
      questionFormAState: FormAState.OPEN,
      questionFormBState: FormBState.OPEN,
    });
  }

  try {
    const state = await fetchState(token);
    return new TokenState(state);
  } catch (err) {
    return new TokenState(null, err);
  }
};

export const getTokenStateFromRoute = route =>
  getTokenState(route.params.token, route.query.noCheck);
